export default __webpack_public_path__ + "static/media/FlightHome.da7247c1.png";